import React from 'react';
import { Row, Col, Table, Form } from 'react-bootstrap';
import Pagination from 'react-js-pagination';
import { useTranslation, Trans } from 'react-i18next';
import { DebounceInput } from 'react-debounce-input';

import { CurrencyPlainText } from 'helpers/Currency';
import { parseDateBR } from 'helpers/date';
import flatten from 'helpers/flatten';
import BootstrapTable from 'react-bootstrap-table-next';
import { renderToString } from 'react-dom/server'

const ListingMarginMarketingPlan = ({
  reports,
  filters,
  stateFilters,
  handleFilterChange
}) => {
  const { t } = useTranslation();
  const handlePageChange = page => handleFilterChange({ page });
  const sortCaretDefaut = (order, column) => {
    if (!order) return (<i style={{float:'right'}} className="fas fa-sort"></i>);
    else if (order === 'asc') return (<i style={{float:'right'}} className="fas fa-sort-down"></i>);
    else if (order === 'desc') return (<i style={{float:'right'}} className="fas fa-sort-up"></i>);
    return null;
  };

  const getPeriod = data => {
    var period = data.company_rule.period;
    var name = period.type.name;

    return name+' '+period.position;
  };

  let detailsArray = [];

  const getDetails = rowId => {
    detailsArray = [];
    {
      Object.values(reports.data).map(report => {
        if(report.id === rowId){
          report.actions.map(action=>{
            let detail = {
              id: action.id,
              task: action.task!=null?action.task.name:'--',
              value: action.margin.value,
              expire: action.margin.expire,
              gasto: action.margin.expense,
              margin: action.margin.margin,
            };
            detailsArray.push(detail);
          });
        }
      });
    }
  };

  const expandRow = {
    renderer: row => (
      <>
        <table bordered hover responsive className="table">
          <thead>
            <tr className="text-center align-middle">
              <th scope="col">ID</th>
              <th scope="col">Categoria</th>
              <th scope="col">Valor</th>
              <th scope="col">Gasto</th>
              <th scope="col">Verba Expirada</th>
              <th scope="col">Margem</th>
            </tr>
          </thead>
          <tbody className="table">
            {getDetails(row.id)}
            {detailsArray.map(info => (
              <tr key={info.id} className="text-center align-middle">
                <td className="text-center align-middle">
                  {info.id}
                </td>
                <td className="text-center align-middle">
                  {info.task}
                </td>
                <td className="text-center align-middle">
                  {info.value.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                              })}
                </td>
                <td className="text-center align-middle">
                  {info.gasto.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                              })}
                </td>
                <td className="text-center align-middle">
                  {info.expire.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                              })}
                </td>
                <td className="text-center align-middle">
                  {(info.margin).toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                              })}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </>
    ),
    onlyOneExpanding: true,
    onExpand: (row,isExpand)=>{
      var btn = document.getElementById(row.id);
      if(isExpand){
        btn.classList.add('fa-minus-circle');
        btn.classList.remove('fa-plus-circle');
      } else {
        btn.classList.remove('fa-minus-circle');
        btn.classList.add('fa-plus-circle');
      }
      var btns = Object.values(document.getElementsByClassName('btne'));
      btns.map(btn=>{
        if(btn.id != row.id)
        if(btn.classList.contains('fa-minus-circle')){
          btn.classList.remove('fa-minus-circle');
          btn.classList.add('fa-plus-circle');
        }
      })
    }
  };

  const columns = [
    {
      dataField: 'btn',
      text: '',
      headerStyle: {
        width: '4%'
      },
      style: {
        textAlign: 'center',
        fontSize: '15px'
      }
    },
    { 
      text: 'ID',
      dataField: 'id',
      headerStyle: {
        textAlign: 'center',
        width: '8%'
      },
      style: {
        textAlign: 'center'
      },
      sort: true,
      sortCaret: sortCaretDefaut,
      onSort: (field, order) => {
        handleFilterChange({ order: order, field: field })
      }
    },
    { 
      text: 'Nome do Plano',
      dataField: 'name', 
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      },
      sort: true,
      sortCaret: sortCaretDefaut,
      onSort: (field, order) => {
        handleFilterChange({ order: order, field: field })
      }
    },
    { 
      text: t('label:company'), 
      dataField: 'company_name', 
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      },
      sort: true,
      sortCaret: sortCaretDefaut,
      onSort: (field, order) => {
        handleFilterChange({ order: order, field: 'company.name' })
      }
    },
    { 
      text: 'Periodo', 
      dataField: 'periodo', 
      headerStyle: {
        textAlign: 'center',
        width: '10%'
      },
      style: {
        textAlign: 'center'
      },
      sort: true,
      sortCaret: sortCaretDefaut,
      onSort: (field, order) => {
        handleFilterChange({ order: order, field: 'period' })
      }
    },
    { 
      text: 'Ano Fiscal', 
      dataField: 'year', 
      headerStyle: {
        textAlign: 'center',
        width: '10%'
      },
      style: {
        textAlign: 'center'
      },
      sort: true,
      sortCaret: sortCaretDefaut,
      onSort: (field, order) => {
        handleFilterChange({ order: order, field: 'company.fiscal_year' })
      }
    },
    { 
      text: 'Margem', 
      dataField: 'margin', 
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      },
      sort: true,
      sortCaret: sortCaretDefaut,
      onSort: (field, order) => {
        handleFilterChange({ order: order, field: 'margin.margin' })
      },
      sortFunc: (a, b, order, dataField) => {
        let add_a = a.substring(1, 0)=='-'?-1:1;
        let add_b = b.substring(1, 0)=='-'?-1:1;
        a = parseFloat(a.replace(a.substring(3, 0),'').replace('.','').replace(',','.'))*add_a;
        b = parseFloat(b.replace(b.substring(3, 0),'').replace('.','').replace(',','.'))*add_b;
        if (order === 'desc') {
          return b - a;
        }
        return a - b;
      }
    },
  ];

  function btn(id) {
    return (<i className="fas fa-plus-circle btne" id={id}></i>)//<i className="fas fa-minus-circle"></i>;
  }

  const reportsData = [];
  const tableExport = [];

  async function getReports() {
    let teste = [];
    Object.values(reports.data).map(report => {
      teste = reportsData.push({
        btn: btn(report.id),
        id: report.id,
        name: report.name,
        company_name: report.company.name+" / "+report.company.alias,
        year:report.company.fiscal_year,
        periodo:getPeriod(report),
        margin:report.margin.margin.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        }),
      });
    });
  }
  
  getReports();
  
  return (
    <>
      <Row>
        <Col>
          <Row>
            <Col md={2}>
              <Form.Group>
                <Form.Label>{t('label:records per page')}:</Form.Label>
                <Form.Control
                  as="select"
                  value={stateFilters.per_page}
                  onChange={e =>
                    handleFilterChange({ per_page: e.target.value, page:1 })
                  }
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>{t('label:company')}:</Form.Label>
                <Form.Control
                  as="select"
                  value={stateFilters.vendor}
                  onChange={e =>
                    handleFilterChange({ vendor: e.target.value, page:1 })
                  }
                >
                  <option value="">Todos</option>
                  {
                    Object.values(reports.vendor).map((vendor, k) => {
                      if (vendor)
                        return (<option value={vendor.id}>{vendor.alias}</option>);
                      return (<></>)
                    })
                  }
                </Form.Control>
              </Form.Group>
            </Col>
            {filters.map((filter, k) => (
              <Col key={k} md={2}>
                <Form.Group>
                  <Form.Label>{t(`label:${filter.name}`)}</Form.Label>
                  <Form.Control
                    value={stateFilters[filter.key]}
                    onChange={e =>
                      handleFilterChange({
                        [filter.key]: e.target.value,
                        page: 1
                      })
                    }
                    as="select"
                  >
                    <option value="">{t('label:all')}</option>
                    {filter.options.map((option, k) => (
                      <option key={k} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            ))}
            <Col md={3} className="ml-auto">
              <Form.Group>
                <Form.Label>{t('label:search')}:</Form.Label>
                <DebounceInput
                  element={Form.Control}
                  debounceTimeout={500}
                  value={stateFilters.search}
                  onChange={e => handleFilterChange({ search: e.target.value, page:1 })}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <BootstrapTable
                id="vendor-report-table"
                keyField="id"
                data={reportsData}
                columns={columns}
                bordered hover responsive
                rowStyle={{fontSize: '13px'}}
                noDataIndication="Valor não Encontrado"
                expandRow={expandRow}
                classes="table-condensed w-auto"
                wrapperClasses='table-responsive'
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Trans i18nKey="label:interpolateShowingRecords">
                Showing {{ from: reports.from || '0' }} to{' '}
                {{ to: reports.to || '0' }} from {{ total: reports.total }}{' '}
                records
              </Trans>
            </Col>
            <Col className="d-flex justify-content-end">
              <Pagination
                activePage={reports.current_page}
                itemsCountPerPage={reports.per_page}
                totalItemsCount={reports.total}
                pageRangeDisplayed={5}
                onChange={handlePageChange}
                itemClass="page-item"
                linkClass="page-link"
                prevPageText="‹"
                nextPageText="›"
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default ListingMarginMarketingPlan;
